var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image__wrapper",class:{'loaded': !_vm.loading },on:{"click":_vm.openImageViewer}},[_c('img',{staticClass:"image__item",style:({ width: _vm.imageWidth }),attrs:{"src":_vm.source}})])}
var staticRenderFns = []

export { render, staticRenderFns }